export default __webpack_public_path__ + "static/media/os_ubuntu.5dd332dd.svg";